/**
 * A type-safe way to access the icon names that are within this icon set, without registering the icons
 *
 * @param name property name of PlannerIconsType
 */ export const PlannerIconName = (name)=>name;
